import React from "react"
import autobind from "class-autobind"
import { Paper, Toggle} from "material-ui"
import { IPosition, IPositionWorkInstructions, IWorkInstructionItem, IWorkItemDescription } from "../../models"
import AccountStore from "../../stores/AccountStore"
import _ from "lodash"
import * as positionHelper from "../../helpers/positionHelper"
import * as scheduleHelper from "../../helpers/scheduleHelper"
import WorkInstructionItemAddDialog from "./WorkInstructionItemAddDialog"

interface IProps {
  readonly: boolean
  positionWorkInstructions: IPositionWorkInstructions
  update(): void
}

interface IState {
  positionList: IPosition[]
  loadingPositions: boolean
  showPositionBudgetDialog: boolean
  positionWorkInstructions: IPositionWorkInstructions
  showAddDialog: boolean
}

export default class PositionWorkInstructions extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      positionList: AccountStore.getCurrentAccount().PositionDefinitions,
      loadingPositions: false,
      showPositionBudgetDialog: false,
      showAddDialog: false,
      positionWorkInstructions: this.props.positionWorkInstructions
    }
    autobind(this)
  }

  componentDidMount() {
  }

  render() {
    let positionColor = positionHelper.getPositionColorFromBasePositionId(this.props.positionWorkInstructions.BasePositionId)

    return (
      <Paper style={{ marginTop: 10, marginBottom: 20, padding: 10, borderRadius: 10 }}>
        <div style={{ 
          color: positionColor,                 
          background: scheduleHelper.getTransparentBackgroundColorFade(positionColor, "#ffffff"),
          paddingLeft: 5, 
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
        }}>
          <span
            style={{
                height: 10,
                width: 10,
                backgroundColor: positionColor,
                borderRadius: "50%",
                marginRight: 5,    
                display: "inline-block",    
            }}
            >
            </span>          
          {this.props.positionWorkInstructions.PositionName}
        </div>
        <div
          style={{
            marginTop: 10,
            display: "flex",
          }}
        >
          {this.state.positionWorkInstructions && 
          this.state.positionWorkInstructions.WorkInstructionItems && 
          this.state.positionWorkInstructions.WorkInstructionItems.map((item, index) => {
            return <div style={{paddingRight: 10}}>
                <Toggle
                      toggled={item.Active}
                      onToggle={(event, value) => { 
                        item.Active = !item.Active
                        this.setState({positionWorkInstructions: this.state.positionWorkInstructions},()=>{
                          this.props.update()
                        })
                      }}
                      labelPosition="left"
                      label={item.ItemName}
                      style={{ 
                        maxWidth: 200,
                        marginBottom: 0, 
                        display: "inline-block"
                      }}
                      disabled={this.props.readonly}
                  />

              </div>
          })}
          {!this.props.readonly &&
            <i
              className="fa fa-plus-circle"
              style={{ fontSize: 20, cursor: "pointer"}}
              onClick={() => this.setState({showAddDialog: true })}
            />
          }
        </div>

        {this.state.showAddDialog &&
          <WorkInstructionItemAddDialog
            handleClose={() => {this.setState({showAddDialog: false})}}            
            handleAdd={(name: string, description: string)=>{ 
              if (!this.props.positionWorkInstructions.WorkInstructionItems) {
                this.props.positionWorkInstructions.WorkInstructionItems = []
              }
              this.props.positionWorkInstructions.WorkInstructionItems.push({
                ItemName: name, 
                Descriptions: [{
                  Description: description
                } as IWorkItemDescription]
              } as IWorkInstructionItem)

              this.props.update()
              this.setState({showAddDialog: false})
            }}
          />
        }

      </Paper>
    )
  }
}